<template>
  <v-row class="main-container">
    <dialog-new-quotation
      v-if="dialogNewQuotation"
      :dialog="dialogNewQuotation"
      v-on:dialog-close="onDialogNewQuotationClose"
    ></dialog-new-quotation>

    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <!-- Shipment information -->
    <dialog-shipment-information
      v-model="selectedShipmentId"
      :dialog="dialogShipmentInformation"
      :tab="shipmentInfoTab"
      v-on:dialog-close="onDialogClose"
    ></dialog-shipment-information>

    <!-- Dialog for managing booking files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="true"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>

    <!-- Dialog for managing invoice -->
    <!-- Remove due to incompatibility with Xero -->
    <!-- <dialog-manage-invoice
      :dialog="dialogManageInvoice"
      v-model="selectedInvoice"
      v-on:dialog-close="onDialogClose"
    ></dialog-manage-invoice> -->

    <!-- warning dialog -->
    <v-dialog v-model="dialogOnConfirmQuotation" max-width="500">
      <v-card v-if="selected_tbc_quotation != null" tile color="white" flat>
        <v-card-title dark class="dialog-header-title"
          >Confirm Quotation</v-card-title
        >
        <v-card-text class="mt-3">
          <v-alert tile outlined type="info" dense prominent border="left">
            <span>
              Upon confirming quotation
              <strong>{{ selected_tbc_quotation.quotation_id }}</strong> the
              booking process will begin.
            </span>
            <br />
            <br />
            <span>Do you want to proceed?</span>
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              class="mr-2 font-weight-bold text-button"
              color="primary"
              depressed
              tile
              @click="confirmQuotation"
              >YES</v-btn
            >
            <v-btn
              class="ml-2 font-weight-bold text-button"
              color="error"
              depressed
              tile
              @click="dialogOnConfirmQuotation = false"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End warning dialog -->

    <!-- warning dialog -->
    <v-dialog v-model="dialogOnCancelBooking" max-width="450">
      <v-card v-if="selected_booking != null" tile color="white" flat>
        <v-card-title dark class="dialog-header-title"
          >Cancel Booking</v-card-title
        >
        <v-card-text class="mt-3">
          <v-alert tile outlined type="warning" dense prominent border="left">
            <span>
              Upon cancelling booking
              <strong>{{ selected_booking.shipment_order_id }}</strong
              >, you will lose the saved booking information and this can't be
              undone.
            </span>
            <br />
            <br />
            <span>Do you want to proceed?</span>
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              class="mx-2 font-weight-bold text-button"
              color="primary"
              depressed
              tile
              @click="cancelBooking"
              >YES</v-btn
            >
            <v-btn
              class="ml-2 font-weight-bold text-button"
              color="error"
              depressed
              tile
              @click="dialogOnCancelBooking = false"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End warning dialog -->

    <!-- Shipment workflow dialog -->
    <v-dialog v-model="dialogShipmentWorkflow" max-width="90%">
      <template v-if="selectedShipment != null && dialogShipmentWorkflow">
        <v-card
          flat
          tile
          :color="
            selectedShipment.shipment_workflow.completed
              ? 'white'
              : 'grey lighten-5'
          "
        >
          <v-card-title class="dialog-header-title"
            >Shipment Workflow for
            {{ selectedShipment.shipment_order_id }}</v-card-title
          >
          <v-card-text class="pb-0 px-0">
            <shipment-workflow-view
              v-if="dialogShipmentWorkflow"
              :shipment="selectedShipment"
              :color="
                selectedShipment.shipment_workflow.completed
                  ? 'white'
                  : '#FAFAFA'
              "
            ></shipment-workflow-view>
          </v-card-text>

          <v-divider class="my-0"></v-divider>

          <v-card-actions>
            <v-row justify="end">
              <v-btn
                class="font-weight-bold"
                color="error"
                depressed
                tile
                dark
                @click="dialogShipmentWorkflow = false"
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="my-2 mx-4">
      <v-col>
        <span class="display-1 primary--text"
          >Hi {{ $root.useraccount.first_name }}!</span
        >
      </v-col>

      <v-col cols="10">
        <v-alert
          border="left"
          style="z-index: 1"
          tile
          colored-border
          type="info"
          elevation="4"
          dense
        >
          Should you have any feedback, we are keen to listen to them. Feel free
          to email us at
          <a href="mailto: feedback@accelefreight.com"
            >feedback@accelefreight.com</a
          >.
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="my-1 py-1"></v-divider>
    </v-row>

    <v-row v-if="$root.is_allow_access" no-gutters>
      <v-col cols="12">
        <v-row>
          <!-- Quotations -->
          <v-col cols="12" sm="12" md="6" lg="4">
            <v-card color="white" tile class="elevation-4" min-height="350">
              <v-card-title class="pt-1" dark>
                <v-row no-gutters>
                  <v-col style="min-width: 120px; max-width: 100%">
                    <v-row justify="start">
                      <span class="primary--text text--darken-1 headline">
                        <span
                          class="error--text font-weight-bold headline mr-2"
                          >{{ tbc_open_quotations }}</span
                        >Quotation(s)
                      </span>
                    </v-row>
                    <v-row>
                      <span class="primary--text text--darken-1 body-2"
                        >to be confirmed</span
                      >
                    </v-row>
                  </v-col>

                  <v-col cols="5" class="d-flex justify-content-end pt-2">
                    <v-btn
                      class="font-weight-bold caption px-1"
                      small
                      tile
                      color="primary white--text"
                      depressed
                      @click="onCreateQuotation"
                      v-if="$root.allow_access"
                      >CREATE QUOTATION</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-title>
              <v-row>
                <v-divider class="mt-0 pt-0"></v-divider>
              </v-row>

              <v-card-text
                class="mt-0 pt-0 px-0"
                v-if="tbc_open_quotations_list.length > 0"
              >
                <v-card
                  flat
                  color="white"
                  min-height="200"
                  max-height="200"
                  style="overflow: auto"
                >
                  <v-card-text class="mt-0 pt-0 px-0">
                    <template v-for="(item, i) in tbc_open_quotations_list">
                      <v-card
                        :key="i"
                        v-if="item.status < CONSTANT.STATUS.QUOTATION.CONFIRMED"
                        tile
                        flat
                        class="px-2 py-1"
                      >
                        <v-row :key="`${i}--row`" no-gutters>
                          <v-col cols="1" class="mr-2 py-2">
                            <div
                              style="background-color: #1976d2"
                              class="rounded-icon"
                            >
                              <v-icon
                                size="23"
                                class="d-flex justify-content-center pt-1"
                                color="white"
                                >{{ getQuotationType(item).icon }}</v-icon
                              >
                            </div>
                          </v-col>

                          <v-col>
                            <v-row
                              justify="space-between"
                              class="mb-1"
                              no-gutters
                            >
                              <v-col>
                                <span
                                  class="font-weight-bold body-2 black--text"
                                  >{{ item.quotation_id }}</span
                                >
                              </v-col>

                              <v-col class="grey--text text--darken-2">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="font-weight-bold caption"
                                      >{{ item.origin.un_code }}</span
                                    >
                                  </template>
                                  {{ item.origin.label }}
                                </v-tooltip>

                                <span
                                  class="
                                    font-weight-light
                                    caption
                                    text-lowercase
                                    mx-2
                                  "
                                  >to</span
                                >

                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="font-weight-bold caption"
                                      >{{ item.destination.un_code }}</span
                                    >
                                  </template>
                                  {{ item.destination.label }}
                                </v-tooltip>
                              </v-col>

                              <v-col
                                class="d-flex justify-content-end mt-1"
                                v-if="
                                  $root.is_admin &&
                                  item.status <
                                    CONSTANT.STATUS.QUOTATION.PROPOSED
                                "
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      x-small
                                      outlined
                                      tile
                                      color="primary white--text"
                                      @click="onProposeQuotation(item)"
                                      class="
                                        font-weight-bold
                                        overline
                                        px-1
                                        mb-1
                                      "
                                      >PROPOSE</v-btn
                                    >
                                  </template>
                                  Click to accept & propose quotation
                                </v-tooltip>
                              </v-col>

                              <v-col
                                class="d-flex justify-content-end mt-1"
                                v-else-if="
                                  item.status ==
                                  CONSTANT.STATUS.QUOTATION.PROPOSED
                                "
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      x-small
                                      outlined
                                      tile
                                      color="green darken-3 white--text"
                                      @click="onConfirmQuotation(item)"
                                      class="
                                        font-weight-bold
                                        overline
                                        px-1
                                        mb-1
                                      "
                                      >CONFIRM</v-btn
                                    >
                                  </template>
                                  Click to confirm quotation
                                </v-tooltip>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-row
                                  no-gutters
                                  class="
                                    font-weight-bold
                                    overline
                                    grey--text
                                    text--darken-2
                                  "
                                >
                                  <span>
                                    {{
                                      item.transaction_type == "EXPORT"
                                        ? "EXP"
                                        : "IMP"
                                    }}
                                    |
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <span v-on="on"
                                          >{{ item.cargo_type.code }} |</span
                                        >
                                      </template>
                                      {{ item.cargo_type.label }}
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <span v-on="on" class="ml-1">
                                          {{ item.crd_string || "N/A" }}
                                        </span>
                                      </template>
                                      Cargo ready date
                                    </v-tooltip>
                                  </span>

                                  <v-tooltip bottom v-if="$root.is_admin">
                                    <template v-slot:activator="{ on }">
                                      <span
                                        v-if="$root.is_admin"
                                        v-on="on"
                                        style="max-width: 60px"
                                        class="
                                          ml-1
                                          d-inline-block
                                          text-truncate
                                        "
                                        >| {{ item.company.name }}</span
                                      >
                                    </template>
                                    {{ item.company.name }}
                                  </v-tooltip>
                                </v-row>
                              </v-col>

                              <v-col
                                cols="4"
                                class="d-flex justify-content-end"
                                v-if="
                                  item.has_complete_price ||
                                  item.override_has_complete_price
                                "
                              >
                                <span class="font-weight-bold caption">
                                  {{ item.currency }}
                                  {{
                                    item.price_estimate_total != null
                                      ? item.price_estimate_total.toLocaleString(
                                          "en-US",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )
                                      : "TBC"
                                  }}
                                </span>
                              </v-col>

                              <v-col
                                v-else
                                cols="4"
                                class="d-flex justify-content-end"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="font-weight-bold caption"
                                    >
                                      TBC
                                    </span>
                                  </template>
                                  Incomplete price
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-divider
                        class="mt-0 pt-0 mb-1"
                        v-if="i < tbc_open_quotations_list.length - 1"
                        :key="`${i}--d`"
                      ></v-divider>
                    </template>
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-card-text v-else>
                <v-card flat color="white" min-height="180">
                  <v-row v-if="quotationsBlockUIShow" class="pt-7">
                    <v-col class="d-flex justify-center">
                      <v-progress-circular
                        :size="70"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </v-col>
                  </v-row>

                  <v-row justify="center" v-else>
                    <v-alert tile style="z-index: 1" type="info" class="my-10"
                      >There are no Quotations to be confirmed</v-alert
                    >
                  </v-row>
                </v-card>
              </v-card-text>

              <v-row>
                <v-divider class="my-0 py-0"></v-divider>
              </v-row>

              <v-card-actions v-if="$root.allow_access">
                <v-row no-gutters>
                  <v-col class="d-flex justify-content-end">
                    <v-btn
                      class="
                        font-weight-bold
                        text-uppercase
                        body-2
                        text--darken-1
                      "
                      text
                      color="primary"
                      style="text-decoration: none"
                      :to="{ name: 'quotations' }"
                      >View Quotations</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- Booking -->
          <v-col cols="12" sm="12" md="6" lg="4">
            <v-card color="white" tile class="elevation-4" min-height="350">
              <v-card-title class="pt-1">
                <v-row no-gutters>
                  <v-col style="min-width: 100px; max-width: 100%">
                    <v-row justify="start">
                      <span class="primary--text text--darken-1 headline">
                        <span
                          class="error--text font-weight-bold headline mr-2"
                          >{{ tbc_bookings }}</span
                        >Booking(s)
                      </span>
                    </v-row>
                    <v-row>
                      <span class="primary--text text--darken-1 body-2"
                        >in progress</span
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-row>
                <v-divider class="mt-0 pt-0"></v-divider>
              </v-row>

              <v-card-text
                class="mt-0 pt-0 px-0"
                v-if="tbc_booking_list.length > 0"
              >
                <v-card
                  flat
                  color="white"
                  min-height="200"
                  max-height="200"
                  style="overflow: auto"
                >
                  <v-card-text class="mt-0 pt-0 px-0">
                    <template v-for="(item, i) in tbc_booking_list">
                      <v-card
                        :key="i"
                        v-if="
                          item.status <
                          CONSTANT.STATUS.SHIPMENT_ORDER.BOOKING_CONFIRMED
                        "
                        tile
                        flat
                        class="px-2 py-1"
                      >
                        <v-row no-gutters>
                          <v-col cols="1" class="mr-2 py-2">
                            <div
                              style="background-color: #1976d2"
                              class="rounded-icon"
                            >
                              <v-icon
                                size="23"
                                class="d-flex justify-content-center pt-1"
                                color="white"
                                >{{ getQuotationType(item).icon }}</v-icon
                              >
                            </div>
                          </v-col>

                          <v-col>
                            <v-row no-gutters>
                              <v-col>
                                <span
                                  class="font-weight-bold body-2 black--text"
                                  >{{ item.shipment_order_id }}</span
                                >
                              </v-col>

                              <v-col>
                                <span
                                  class="
                                    font-weight-bold
                                    caption
                                    grey--text
                                    text--darken-2
                                  "
                                >
                                  {{
                                    item.transaction_type == "EXPORT"
                                      ? "EXP"
                                      : "IMP"
                                  }}
                                  | {{ item.cargo_type.code }}
                                </span>
                              </v-col>

                              <v-col>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="
                                        font-weight-bold
                                        caption
                                        grey--text
                                        text--darken-2
                                      "
                                      >{{ item.origin.un_code }}</span
                                    >
                                  </template>
                                  {{ item.origin.label }}
                                </v-tooltip>

                                <span
                                  class="
                                    font-weight-light
                                    overline
                                    text-lowercase
                                    mx-1
                                  "
                                  >to</span
                                >

                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="
                                        font-weight-bold
                                        caption
                                        grey--text
                                        text--darken-2
                                      "
                                      >{{ item.destination.un_code }}</span
                                    >
                                  </template>
                                  {{ item.destination.label }}
                                </v-tooltip>
                              </v-col>
                            </v-row>

                            <v-row
                              no-gutters
                              v-if="$root.is_admin"
                              class="mt-1"
                            >
                              <span
                                class="
                                  font-weight-bold
                                  overline
                                  grey--text
                                  text--darken-2
                                "
                                >{{ item.company.name }}</span
                              >
                            </v-row>

                            <v-row no-gutters>
                              <v-col
                                v-if="!item.booking_files_uploaded"
                                class="mt-1"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-chip
                                      v-on="on"
                                      small
                                      outlined
                                      color="error"
                                      style="height: 20px"
                                      class="font-weight-bold px-2 caption"
                                      @click="onUploadBookingDocs(item)"
                                    >
                                      <v-icon size="16" left
                                        >mdi-alert-circle</v-icon
                                      >Documents required
                                    </v-chip>
                                  </template>
                                  Upload invoice & packing list
                                </v-tooltip>
                              </v-col>

                              <v-col v-else class="mt-1">
                                <v-chip
                                  style="height: 20px"
                                  label
                                  color="amber darken-4"
                                  dark
                                  class="font-weight-bold px-1 caption"
                                  >Booking pending</v-chip
                                >
                              </v-col>

                              <v-col class="d-flex justify-content-end">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      small
                                      icon
                                      color="error"
                                      class="pa-0"
                                      @click="onCancelBooking(item)"
                                    >
                                      <v-icon size="20">mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Cancel booking</span>
                                </v-tooltip>

                                <template v-if="$root.is_admin">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        small
                                        icon
                                        color="primary"
                                        class="pa-0"
                                        @click="onManageQuotationDialog(item)"
                                      >
                                        <v-icon size="20"
                                          >mdi-square-edit-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Edit quotation information</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        small
                                        icon
                                        color="primary"
                                        class="pa-0"
                                        @click="onManageShipmentInfo(item, 1)"
                                      >
                                        <v-icon size="20">mdi-tune</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Admin manage booking</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        small
                                        icon
                                        color="primary"
                                        class="pa-0"
                                        @click="onBookingConfirm(item)"
                                      >
                                        <v-icon size="20"
                                          >mdi-file-check-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Confirm booking</span>
                                  </v-tooltip>
                                </template>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-divider
                        class="mt-0 pt-0 mb-1"
                        :key="`${i}--d`"
                      ></v-divider>
                    </template>
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-card-text v-else>
                <v-card flat color="white" min-height="180">
                  <v-row v-if="bookingsBlockUIShow" class="pt-7">
                    <v-col class="d-flex justify-center">
                      <v-progress-circular
                        :size="70"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </v-col>
                  </v-row>

                  <v-row justify="center" v-else>
                    <v-alert tile style="z-index: 1" type="info" class="my-10"
                      >There are no Bookings in progress</v-alert
                    >
                  </v-row>
                </v-card>
              </v-card-text>

              <v-row>
                <v-divider class="my-0 py-0"></v-divider>
              </v-row>

              <v-card-actions v-if="$root.allow_access">
                <v-row no-gutters>
                  <v-col class="d-flex justify-content-end">
                    <v-btn
                      class="
                        font-weight-bold
                        text-uppercase
                        body-2
                        text--darken-1
                      "
                      text
                      color="primary"
                      style="text-decoration: none"
                      :to="{ name: 'bookings' }"
                      >View Bookings</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- Shipments -->
          <v-col cols="12" sm="12" md="6" lg="4">
            <v-card color="white" tile class="elevation-4" min-height="350">
              <v-card-title class="pt-1">
                <v-row no-gutters>
                  <v-col style="min-width: 100px; max-width: 100%">
                    <v-row justify="start">
                      <span class="primary--text text--darken-1 headline">
                        <span
                          class="error--text font-weight-bold headline mr-2"
                          >{{ shipment_in_progress }}</span
                        >Shipment(s)
                      </span>
                    </v-row>
                    <v-row>
                      <span class="primary--text text--darken-1 body-2"
                        >in progress</span
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-row>
                <v-divider class="mt-0 pt-0"></v-divider>
              </v-row>

              <v-card-text
                class="mt-0 pt-0 px-0"
                v-if="shipment_list.length > 0"
              >
                <v-card
                  flat
                  color="white"
                  min-height="200"
                  max-height="200"
                  style="overflow: auto"
                >
                  <v-card-text class="mt-0 pt-0 px-0">
                    <template v-for="(item, i) in shipment_list">
                      <v-card
                        :key="i"
                        @click="onShipmentWorkflowDialog(item)"
                        tile
                        flat
                        class="px-2 py-1"
                      >
                        <v-row no-gutters>
                          <v-col cols="1" class="mr-2 py-2">
                            <div
                              style="background-color: #1976d2"
                              class="rounded-icon"
                            >
                              <v-icon
                                size="23"
                                class="d-flex justify-content-center pt-1"
                                color="white"
                                >{{ getQuotationType(item).icon }}</v-icon
                              >
                            </div>
                          </v-col>

                          <v-col>
                            <v-row no-gutters>
                              <v-col>
                                <span
                                  class="font-weight-bold body-2 black--text"
                                  >{{ item.shipment_order_id }}</span
                                >
                              </v-col>

                              <v-col>
                                <span
                                  class="
                                    font-weight-bold
                                    caption
                                    grey--text
                                    text--darken-3
                                  "
                                >
                                  {{
                                    item.transaction_type == "EXPORT"
                                      ? "EXP"
                                      : "IMP"
                                  }}
                                  | {{ item.cargo_type.code }}
                                </span>
                              </v-col>

                              <v-col class="d-flex justify-end mt-1">
                                <v-chip
                                  x-small
                                  label
                                  dark
                                  color="amber darken-4"
                                  class="font-weight-bold caption px-1"
                                  >{{ item.status_msg }}</v-chip
                                >
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <v-col>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="font-weight-bold overline"
                                    >
                                      <v-icon
                                        size="10"
                                        color="primary"
                                        class="mx-1"
                                        >mdi-checkbox-blank-circle</v-icon
                                      >
                                      {{ item.origin.un_code }}
                                    </span>
                                  </template>
                                  {{ item.origin.label }}
                                </v-tooltip>
                              </v-col>

                              <v-col
                                class="d-flex justify-content-center mt-1"
                                v-if="$root.is_admin"
                              >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      style="max-width: 120px"
                                      class="
                                        ml-1
                                        font-weight-bold
                                        overline
                                        grey--text
                                        text--darken-3
                                        d-inline-block
                                        text-truncate
                                      "
                                      >{{ item.company.name }}</span
                                    >
                                  </template>
                                  {{ item.company.name }}
                                </v-tooltip>
                              </v-col>

                              <v-col class="d-flex justify-content-end mt-1">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="
                                        font-weight-bold
                                        overline
                                        grey--text
                                        text--darken-3
                                      "
                                    >
                                      {{ getScheduleInfo(item).origin_eta }}
                                    </span>
                                  </template>
                                  ETA
                                </v-tooltip>
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <!-- <v-col cols="1">
                                <v-icon size="20" color="primary" class="mr-2">mdi-dots-vertical</v-icon>
                              </v-col>-->
                              <v-col>
                                <span
                                  class="
                                    overline
                                    font-weight-bold
                                    grey--text
                                    text--darken-2
                                    ml-5
                                  "
                                >
                                  {{
                                    getScheduleInfo(item).vessel_name != ""
                                      ? `${
                                          getScheduleInfo(item).vessel_name
                                        } (${
                                          getScheduleInfo(item).vessel_voyage
                                        })`
                                      : ""
                                  }}
                                </span>
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <v-col>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="font-weight-bold overline"
                                    >
                                      <v-icon
                                        size="10"
                                        left
                                        color="error"
                                        class="mx-1"
                                        >mdi-checkbox-blank-circle</v-icon
                                      >
                                      {{ item.destination.un_code }}
                                    </span>
                                  </template>
                                  {{ item.destination.label }}
                                </v-tooltip>
                              </v-col>
                              <v-col
                                class="d-flex justify-content-end mt-0 pt-0"
                              >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-on="on"
                                      class="
                                        font-weight-bold
                                        overline
                                        grey--text
                                        text--darken-3
                                      "
                                    >
                                      {{
                                        getScheduleInfo(item).destination_eta
                                      }}
                                    </span>
                                  </template>
                                  ETA
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-divider
                        v-if="i < shipment_list.length - 1"
                        :key="`${i}--d`"
                      ></v-divider>
                    </template>
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-card-text v-else>
                <v-card flat color="white" min-height="180">
                  <v-row v-if="shipmentsBlockUIShow" class="pt-7">
                    <v-col class="d-flex justify-center">
                      <v-progress-circular
                        :size="70"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </v-col>
                  </v-row>

                  <v-row justify="center" v-else>
                    <v-alert tile style="z-index: 1" type="info" class="my-10"
                      >There are no Shipments in progress</v-alert
                    >
                  </v-row>
                </v-card>
              </v-card-text>

              <v-row>
                <v-divider class="my-0 py-0"></v-divider>
              </v-row>

              <v-card-actions v-if="$root.allow_access">
                <v-row no-gutters>
                  <v-col>
                    <v-row>
                      <span class="font-weight-bold">
                        <span class="error--text">
                          {{ shipment_completed }}
                        </span>
                        Completed shipments
                      </span>
                    </v-row>
                    <v-row>
                      <span class="font-weight-bold">
                        <span class="error--text">{{ total_shipment }}</span>
                        Total shipments
                      </span>
                    </v-row>
                  </v-col>

                  <v-col class="d-flex justify-content-end">
                    <v-btn
                      class="
                        font-weight-bold
                        text-uppercase
                        body-2
                        text--darken-1
                      "
                      text
                      color="primary"
                      style="text-decoration: none"
                      :to="{ name: 'shipments' }"
                      >View Shipments</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <!-- Invoices -->
          <!-- Removed due to incompatibility with Xero -->
          <!-- <v-col cols="12" sm="12" md="7" lg="6">
            <v-card color="white" tile class="elevation-4" min-height="350">
              <v-card-title class="pt-1" dark>
                <v-row no-gutters>
                  <v-col style="min-width: 120px; max-width: 100%">
                    <v-row justify="start">
                      <span class="primary--text text--darken-1 headline">
                        <span class="error--text font-weight-bold headline mr-2">{{
                          authorised_invoices
                        }}</span
                        >Invoice(s)
                      </span>
                    </v-row>
                    <v-row>
                      <span class="primary--text text--darken-1 body-2"
                        >awaiting payment</span
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-row>
                <v-divider class="mt-0 pt-0"></v-divider>
              </v-row>

              <v-card-text
                class="mt-0 pt-0 px-0"
                v-if="authorised_invoices_list.length > 0"
              >
                <v-card
                  flat
                  color="white"
                  min-height="200"
                  max-height="200"
                  style="overflow: auto"
                >
                  <v-card-text class="mt-0 pt-0 px-0">
                    <template v-for="(item, i) in authorised_invoices_list">
                      <v-card :key="i" tile flat class="px-2 py-1">
                        <v-row :key="`${i}--row`" no-gutters>
                          <v-col cols="1" class="py-2">
                            <div style="background-color: #1976d2" class="rounded-icon">
                              <v-icon
                                size="23"
                                class="d-flex justify-content-center pt-1"
                                color="white"
                                >mdi-receipt</v-icon
                              >
                            </div>
                          </v-col>

                          <v-col>
                            <v-row justify="space-between" class="mb-1" no-gutters>
                              <v-col cols="2">
                                <span class="font-weight-bold body-2 black--text">{{
                                  item.invoice_id
                                }}</span>
                              </v-col>

                              <v-col class="grey--text text--darken-3 d-flex justify-end">
                                <span class="font-weight-bold caption">
                                  {{ item.quotation_id }}
                                </span>
                                <span class="mx-2">|</span>
                                <span class="font-weight-bold caption"
                                  >Issued {{ item.issued_date }}</span
                                >
                                <span class="mx-2">|</span>
                                <span
                                  v-if="!item.overdue"
                                  class="font-weight-bold caption"
                                  >Due {{ item.due_date }}</span
                                >
                                <span v-if="item.overdue" class="caption error--text">
                                  <span class="font-weight-bold">Overdue by:</span>
                                  {{ `${item.overdue_by} days` }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row no-gutters class="pt-1">
                              <v-col>
                                <v-row
                                  justify="start"
                                  class="font-weight-bold grey--text text--darken-2"
                                >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        x-small
                                        icon
                                        color="primary"
                                        class="font-weight-bold mr-2"
                                        @click="downloadInvoice(item)"
                                      >
                                        <v-icon size="20">mdi-download</v-icon>
                                      </v-btn>
                                    </template>
                                    Download Invoice
                                  </v-tooltip>

                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        v-if="$root.is_admin"
                                        x-small
                                        icon
                                        color="primary"
                                        class="font-weight-bold mx-2"
                                        @click="onManageInvoice(item)"
                                      >
                                        <v-icon size="20">mdi-square-edit-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    Edit invoice detail
                                  </v-tooltip>
                                </v-row>
                              </v-col>

                              <v-col cols="5" v-if="$root.is_admin">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <span
                                      v-if="$root.is_admin"
                                      v-on="on"
                                      class="ml-4 pt-1 text-uppercase caption font-weight-bold"
                                      >{{ item.company.short_name }}</span
                                    >
                                  </template>
                                  {{ item.company.name }}
                                </v-tooltip>
                              </v-col>

                              <v-col cols="4" class="d-flex justify-content-end">
                                <span class="font-weight-bold body-2">
                                  {{ item.currency }}
                                  {{
                                    item.amount_due.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  }}
                                </span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-divider
                        class="mt-0 pt-0 mb-1"
                        v-if="i < authorised_invoices_list.length - 1"
                        :key="`${i}--d`"
                      ></v-divider>
                    </template>
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-card-text v-else>
                <v-card flat color="white" min-height="180">
                  <v-row v-if="invoicesBlockUIShow" class="pt-7">
                    <v-col class="d-flex justify-center">
                      <v-progress-circular
                        :size="70"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </v-col>
                  </v-row>

                  <v-row justify="center" v-else>
                    <v-alert tile style="z-index: 1" type="info" class="my-10"
                      >There are no Invoices awaiting payment</v-alert
                    >
                  </v-row>
                </v-card>
              </v-card-text>

              <v-row>
                <v-divider class="my-0 py-0"></v-divider>
              </v-row>

              <v-card-actions v-if="$root.allow_access">
                <v-row no-gutters>
                  <v-col class="d-flex justify-content-end">
                    <v-btn
                      class="font-weight-bold text-uppercase body-2 text--darken-1"
                      text
                      color="primary"
                      style="text-decoration: none"
                      :to="{ name: 'invoices' }"
                      >View Invoices</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col> -->

          <!-- Shipment Chart -->
          <v-col>
            <v-card color="white" class="elevation-4" width="600">
              <v-row v-if="weeklyShipmentsBlockUIShow" class="pt-2">
                <v-col class="d-flex justify-center">
                  <v-progress-circular
                    :size="50"
                    :width="5"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col>
                  <v-row no-gutters>
                    <v-col>
                      <GChart
                        type="ColumnChart"
                        :data="chartData"
                        :options="chartOptions"
                        style="
                          border: 1px solid grey;
                          box-shadow: none;
                          border-radius: 4px;
                        "
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters class="pt-2">
                    <v-col>
                      <v-row>
                        <span class="font-weight-bold">
                          <span class="error--text">
                            {{ shipment_without_schedule.total }}
                          </span>
                          {{
                            shipment_without_schedule.total > 1
                              ? "Shipments"
                              : "Shipment"
                          }}
                          without schedule
                        </span>
                      </v-row>

                      <v-row>
                        <span class="font-weight-bold">
                          <span class="error--text">
                            {{ open_arrived_departed_shipments.total }}
                          </span>
                          Open arrived/departed
                          {{
                            open_arrived_departed_shipments.total > 1
                              ? "shipments"
                              : "shipment"
                          }}
                        </span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else justify="center">
      <v-card color="white">
        <v-row>
          <v-col cols="12" class="pa-1">
            <v-alert type="error" v-model="company_registration_alert">
              You have not registered your company. Please goto the user account
              management to proceed with the company registration.
              <v-btn
                small
                class="font-weight-bold"
                color="black"
                @click="onAccountManagement"
                >Account management</v-btn
              >
              <br />If your company is already registered, you may reach out to
              us at
              <a href="mailto: info@accelefreight.com"
                >info@accelefreight.com</a
              >
              to get your account assigned under your company.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pa-1">
            <v-alert
              type="info"
              color="orange"
              v-model="company_validation_alert"
            >
              Your registered company is pending validation by our
              administrators. You will have access to all our features once the
              validation process is successfully completed.
              <br />At the meantime, you can reach out to us at
              <a href="mailto: info@accelefreight.com"
                >info@accelefreight.com</a
              >
              should you have any questions, we'll be more than happy to assist
              you.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pa-1">
            <v-alert type="error">
              There is an issue with your accessibility to our platform. Please
              reach out to us at
              <a href="mailto: info@accelefreight.com">info@accelefreight.com</a
              >, we'll be more than happy to assist you.
            </v-alert>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import ShipmentWorkflowView from "@/components/shared/ShipmentWorkflowView.vue"
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation"
import DialogShipmentInformation from "@/components/user/DialogShipmentInformation.vue"
import DialogFileCabinet from "@/components/user/DialogFileCabinet.vue"
import DialogManageInvoice from "@/components/admin/dialogs/DialogManageInvoice"

export default {
  components: {
    ShipmentWorkflowView,
    DialogManageQuotation,
    DialogShipmentInformation,
    DialogFileCabinet,
    DialogManageInvoice,
  },
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      quotationsBlockUIShow: true,
      bookingsBlockUIShow: true,
      shipmentsBlockUIShow: true,
      invoicesBlockUIShow: true,
      weeklyShipmentsBlockUIShow: true,

      dialogNewQuotation: false,
      selectedQuotation: null,

      dialogManageQuotation: false,

      dialogOnConfirmQuotation: false,
      selected_tbc_quotation: null,

      dialogShipmentInformation: false,
      selectedShipmentId: null,
      selectedCompanyId: null,
      selectedShipment: null,
      shipmentInfoTab: null,

      dialogFileCabinet: false,

      dialogShipmentWorkflow: false,

      dialogManageInvoice: false,
      selectedInvoice: null,

      tbc_open_quotations: 0,
      tbc_open_quotations_list: [],

      tbc_bookings: 0,
      tbc_booking_list: [],
      dialogOnCancelBooking: false,
      selected_booking: null,

      total_shipment: 0,
      shipment_in_progress: 0,
      shipment_completed: 0,
      shipment_list: [],

      authorised_invoices: 0,
      total_invoice_amount_due: 0,
      authorised_invoices_list: [],

      shipment_without_schedule: {
        import_shipments: 0,
        export_shipments: 0,
        total: 0,
      },

      open_arrived_departed_shipments: {
        import_shipments: 0,
        export_shipments: 0,
        total: 0,
      },

      chartData: [
        ["Week", "Import", "Export"],
        ["Week 0", 0, 0],
        ["Week 1", 0, 0],
        ["Week 2", 0, 0],
        ["Week 3", 0, 0],
        ["Week 4", 0, 0],
      ],

      chartOptions: {
        isStacked: true,
        title: "Weekly import/export",
        legend: { position: "none" },
        height: 148,
        width: 500,
      },
    }
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token()

    this.onInit()
  },

  methods: {
    /**
     * Dashboard API call
     */
    async onInit() {
      if (this.$root.is_allow_access) {
        // call quotations dashboard
        this.loadQuotations()

        // call bookings dashboard
        this.loadBookings()

        // call shipments dashboard
        this.loadShipments()

        // call shipments statistics dashboard
        this.loadShipmentsStat()

        // call invoices dashboard
        // this.$https.get("/api/dashboard/invoices").then((resp) => {
        //   if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        //     // Invoice summary
        //     this.authorised_invoices = resp.data.data.authorised_invoices
        //     this.total_invoice_amount_due = resp.data.data.total_amount_due
        //     this.authorised_invoices_list =
        //       resp.data.data.authorised_invoices_list
        //   } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
        //     // logout user
        //     this.$root.logout()
        //   }
        //   this.invoicesBlockUIShow = false
        // })

        // call weekly shipments dashboard
        this.$https.get("/api/dashboard/weekly_shipments").then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            // Shipment weekly report
            this.chartData = []
            this.chartData.push(["Week", "Import", "Export"])

            for (var week in resp.data.data.summary) {
              this.chartData.push([
                `Week ${week}`,
                resp.data.data.summary[week].import,
                resp.data.data.summary[week].export,
              ])
            }
          } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
            // logout user
            this.$root.logout()
          }
          this.weeklyShipmentsBlockUIShow = false
        })
      }
    },

    /**
     * Load Quotation
     */
    async loadQuotations() {
      this.tbc_open_quotations_list = []
      this.quotationsBlockUIShow = true

      // call quotation dashboard
      let resp = await this.$https.get("/api/dashboard/quotations")
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // Quotation Summary
        this.tbc_open_quotations = resp.data.data.tbc_open_quotations
        this.tbc_open_quotations_list = resp.data.data.tbc_open_quotations_list
      } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
        // logout user
        this.$root.logout()
      }
      this.quotationsBlockUIShow = false
    },

    /**
     * Load Booking
     */
    async loadBookings() {
      this.tbc_booking_list = []
      this.bookingsBlockUIShow = true

      // call booking dashboard
      let resp = await this.$https.get("/api/dashboard/bookings")
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // Booking summary
        this.tbc_bookings = resp.data.data.tbc_bookings
        this.tbc_booking_list = resp.data.data.tbc_booking_list
      } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
        // logout user
        this.$root.logout()
      }
      this.bookingsBlockUIShow = false
    },

    /**
     * Load Shipments
     */
    async loadShipments() {
      this.shipment_list = []
      this.shipmentsBlockUIShow = true

      // call shipment dashboard
      let resp = await this.$https.get("/api/dashboard/shipments")
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // Shipment sumarry
        this.total_shipment = resp.data.data.total_shipment
        this.shipment_in_progress = resp.data.data.shipment_in_progress
        this.shipment_completed = resp.data.data.shipment_completed
        this.shipment_list = resp.data.data.shipment_list
      } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
        // logout user
        this.$root.logout()
      }
      this.shipmentsBlockUIShow = false
    },

    /**
     * Load Shipments statistics
     */
    async loadShipmentsStat() {
      this.shipmentsBlockUIShow = true

      // call shipments stat dashboard
      let resp = await this.$https.get("/api/dashboard/shipments_stats")
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // Shipment stats for shipments without schedule
        this.shipment_without_schedule =
          resp.data.data.shipment_without_schedule

        // Shipment stats for open shipments with schedule
        this.open_arrived_departed_shipments =
          resp.data.data.open_arrived_departed_shipments
      } else if (resp.data.status == constant.RESPONSE_STATUS_LOGOUT) {
        // logout user
        this.$root.logout()
      }
      this.shipmentsBlockUIShow = false
    },

    onAccountManagement() {
      this.$router.push({ name: "useraccount" })
    },

    /**
     * On create a new quotation
     */
    async onCreateQuotation() {
      this.$root.blockUImsg = "Initialising..."
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()
      this.$root.blockUIshow = false

      // open the create new quotation dialog
      this.dialogNewQuotation = true
    },

    onDialogNewQuotationClose(newQuotation, wasCreated) {
      this.dialogNewQuotation = false
      if (wasCreated) {
        this.onInit()
        this.$root.blockUIshow = false
      }
      this.$root.blockUIshow = false
    },

    /**
     * Required documents
     */
    requiredDocs(files) {
      let ret = []
      constant.BOOKING_FILES.forEach((item) => {
        if (!files.includes(item)) {
          ret.push(item)
        }
      })
      return ret
    },

    /**
     * Check for missing booking files
     */
    checkForMissingBookingFiles(docs) {
      var status = false
      for (let i = 0; i < docs.length; i++) {
        const element = docs[i]
        // if uploaded is false, then one file is missing
        if (!element.uploaded) {
          status = true
          break
        }
      }
      return status
    },

    /**
     * Get the shipment type
     * @param {object} quotation
     */
    getQuotationType(quotation) {
      var color = "error"
      var title = ""
      var icon = "mdi-alert-circle"

      switch (quotation.quotation_type) {
        case constant.QUOTATION_TYPE_SEA_FCL:
          color = "primary"
          // color = "white";
          title = "FCL"
          icon = "mdi-ferry"
          break
        case constant.QUOTATION_TYPE_SEA_LCL:
          color = "primary"
          // color = "white";
          title = "LCL"
          icon = "mdi-ferry"
          break
        case constant.QUOTATION_TYPE_AIR:
          color = "secondary"
          // color = "white";
          title = "AIR"
          icon = "mdi-airplane-takeoff"
          break
        case constant.QUOTATION_TYPE_WAREHOUSE:
          color = "blue-grey"
          // color = "white";
          title = "WH"
          icon = "mdi-warehouse"
          break
        default:
          break
      }

      return { icon: icon, color: color, title: title }
    },

    /**
     * Get the quotation status
     * @param {object} quotation
     */
    getQuotationStatus(quotation) {
      var color = "grey darken-3"
      var msg = "Draft quotation, price to be finalized"
      var title = "Draft"

      switch (quotation.status) {
        case constant.STATUS.QUOTATION.EXPIRED:
          color = "error"
          title = "Expired"
          msg =
            "Quotation has already expired. Please refresh the quotation or create a new one"
          break
        case constant.STATUS.QUOTATION.DRAFT:
          break
        case constant.STATUS.QUOTATION.PROPOSED:
          color = "amber darken-4"
          title = "Proposed"
          msg =
            "This quotation is proposed. Please confirm the quotation to proceed with booking"
          break
        case constant.STATUS.QUOTATION.PRICE_UPDATED:
          color = "teal darken-3"
          title = "Price Updated"
          msg =
            "A new price is updated for this quotation. Please confirm the quotation to proceed with booking"
          break

        default:
          title = null
          msg = "This quotation has no status"
          break
      }
      return { color: color, title: title, msg: msg }
    },

    /**
     * Get the Schedule Information
     * @param {object} shipment
     */
    getScheduleInfo(shipment) {
      var vessel_name = ""
      var vessel_voyage = ""
      var airline = ""
      var origin_eta = "ETA: N/A"
      var destination_eta = "ETA: N/A"

      // validate vessel name
      if (shipment.shipment_schedule.vessel_name != null) {
        vessel_name = shipment.shipment_schedule.vessel_name
      }

      // validate vessel voyage
      if (shipment.shipment_schedule.origin_schedule != null) {
        if (shipment.shipment_schedule.origin_schedule.vessel_voyage != null) {
          vessel_voyage =
            shipment.shipment_schedule.origin_schedule.vessel_voyage
        }
      }

      // validate orign eta
      if (shipment.shipment_schedule.origin_eta_string != null) {
        origin_eta = `${shipment.shipment_schedule.origin_eta_string}`
      }

      // validate destination eta
      if (shipment.shipment_schedule.destination_eta_string != null) {
        destination_eta = `${shipment.shipment_schedule.destination_eta_string}`
      }
      return {
        vessel_name: vessel_name,
        vessel_voyage: vessel_voyage,
        origin_eta: origin_eta,
        destination_eta: destination_eta,
      }
    },

    /**
     *  on propose quotation
     */
    async onProposeQuotation(quotation) {
      this.$root.blockUImsg = "Proposing quotation"
      this.$root.blockUIshow = true

      let resp = await this.$https.put(
        `/api/quotations/${quotation.quotation_id}/status/${constant.STATUS.QUOTATION.PROPOSED}`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the quotation status
        quotation.status = constant.STATUS.QUOTATION.PROPOSED
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = `Quotation ${quotation.quotation_id} proposed successfully`
      } else {
        console.log(resp.data)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }
      this.$root.blockUIshow = false
    },

    /** On confirm Quotation */
    onConfirmQuotation(quotation) {
      this.selected_tbc_quotation = quotation
      this.dialogOnConfirmQuotation = true
    },

    /**
     * Confirm quotation
     */
    async confirmQuotation() {
      this.$root.blockUImsg = "Confirming quotation"
      this.$root.blockUIshow = true

      let resp = await this.$https.post(
        `/api/quotations/${this.selected_tbc_quotation.quotation_id}/confirm`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.selected_tbc_quotation.status = constant.STATUS.QUOTATION.CONFIRMED

        // remove selected confirmed quotation
        this.tbc_open_quotations_list = this.tbc_open_quotations_list.filter(
          (item) => {
            return item != this.selected_tbc_quotation
          }
        )
        // decrement the tbc open quotation count by 1
        this.tbc_open_quotations -= 1

        this.dialogOnConfirmQuotation = false
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = "Quotation confirmed successfully"

        // refresh after 4 sec
        setTimeout(() => {
          // refresh the bookings dashboard card
          this.loadBookings()
        }, 4000)
      } else {
        console.log(resp.data)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }
      this.$root.blockUIshow = false
    },

    /** On cancel booking */
    onCancelBooking(booking) {
      this.selected_booking = booking
      this.dialogOnCancelBooking = true
    },

    /** Cancel Booking */
    async cancelBooking() {
      this.$root.blockUImsg = "Cancelling booking"
      this.$root.blockUIshow = true

      let resp = await this.$https.put(
        `/api/quotations/${this.selected_booking.shipment_order_id}/booking_cancelled`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg

        // remove booking
        this.tbc_booking_list = this.tbc_booking_list.filter((item) => {
          return item != this.selected_booking
        })

        // decrement the tbc booking count by 1
        this.tbc_bookings -= 1

        this.selected_booking = null
        this.dialogOnCancelBooking = false

        // refresh after 4 sec
        setTimeout(() => {
          // refresh the quotation dashboard card
          this.loadQuotations()
        }, 4000)
      } else {
        console.error(resp.data)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /**
     * on upload documents for booking
     */
    onUploadBookingDocs(booking) {
      this.selectedShipmentId = booking.shipment_order_id
      this.selectedCompanyId = booking.company_id
      this.dialogFileCabinet = true
    },

    /**
     *  on confirming booking
     */
    async onBookingConfirm(booking) {
      this.$root.blockUImsg = "Confirming booking"
      this.$root.blockUIshow = true

      let resp = await this.$https.put(
        `/api/shipment_orders/${booking.shipment_order_id}/booking_confirmed`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the booking status
        booking.status = constant.STATUS.SHIPMENT_ORDER.BOOKING_CONFIRMED

        // remove the selected confirmed booking
        this.tbc_booking_list = this.tbc_booking_list.filter((item) => {
          return item != booking
        })
        // decrement the tbc booking count by 1
        this.tbc_bookings -= 1

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg

        // refresh after 4 sec
        setTimeout(() => {
          // refresh the shipments dashboard card
          this.loadShipments()
        }, 4000)
      } else {
        console.error(resp.data)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }
      this.$root.blockUIshow = false
    },

    /**
     * On open quotation relate dialogs
     */
    async onManageQuotationDialog(booking) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true

      let resp = await this.$https.get(
        "/api/quotations/" + booking.shipment_order_id
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.selectedQuotation = resp.data.data
        this.dialogManageQuotation = true
      }

      this.$root.blockUIshow = false
    },

    /**
     *  Open shipment information
     */
    onManageShipmentInfo(shipment, tab) {
      this.selectedShipmentId = shipment.shipment_order_id
      this.shipmentInfoTab = tab
      this.dialogShipmentInformation = true
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false
      this.selectedQuotation = null

      if (hasChange && !isReAssigned) {
        this.onInit()
        this.$root.blockUIshow = false
      }
    },

    /**
     * close the page
     */
    onDialogClose(dialog, object, hasChange) {
      switch (dialog) {
        case constant.DIALOG_SHIPMENT_INFORMARTION:
          this.dialogShipmentInformation = false
          this.shipmentInfoTab = null
          break
        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false

          this.selectedShipment = null
          break

        case constant.DIALOG_MANAGE_INVOICE:
          this.dialogManageInvoice = false
          this.selectedInvoice = null
          break
      }

      if (hasChange == true) {
        this.onInit()
        this.$root.blockUIshow = false
      }

      this.selectedShipmentId = null
      this.selectedCompanyId = null
    },

    /**
     * On open shipment workflow dialog
     */
    async onShipmentWorkflowDialog(shipment) {
      // get the shipment workflow summary
      this.$root.blockUImsg = "please wait..."
      this.$root.blockUIshow = true

      let resp = await this.$https.get(
        `/api/shipment_orders/${shipment.shipment_order_id}/workflow`
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.selectedShipment = resp.data.data

        this.dialogShipmentWorkflow = true
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /**
     * manage invoice
     */
    async onManageInvoice(invoice) {
      // this.$root.blockUImsg = "Loading invoice information"
      // this.$root.blockUIshow = true
      // let resp = await this.$https.get(`/api/invoices/${invoice.invoice_id}`)
      // if (resp.data.status == constant.RESPONSE_STATUS_OK) {
      //   this.selectedInvoice = resp.data.data
      //   this.dialogManageInvoice = true
      // } else {
      //   console.log("OnManageInvoice Error: ", resp.data)
      // }
      // this.$root.blockUIshow = false
    },

    /**
     * Download Invoice
     */
    async downloadInvoice(invoice) {
      // this.$root.blockUImsg = "Downloading Invoice..."
      // this.$root.blockUIshow = true
      // let resp = await this.$https.get(
      //   `/api/invoices/${invoice.invoice_id}/download_pdf`,
      //   {
      //     responseType: "blob",
      //   }
      // )
      // const url = window.URL.createObjectURL(new Blob([resp.data]))
      // const link = document.createElement("a")
      // link.href = url
      // link.setAttribute("download", `${invoice.invoice_id}.pdf`)
      // document.body.appendChild(link)
      // link.click()
      // link.remove()
      // this.showSnackbar = true
      // this.snackbarColor = "success"
      // this.snackbarMsg = `Invoice ${invoice.invoice_id} successfully downloaded`
      // this.$root.blockUIshow = false
    },
  },

  computed: {
    company_registration_alert: {
      get() {
        return !this.$root.is_valid_company
      },
    },

    company_validation_alert: {
      get() {
        return !this.$root.is_company_approved
      },
    },
  },
}
</script>

<style>
.rounded-icon {
  border-radius: 50%;
  height: 32px;
  width: 32px;
}
.v-alert {
  margin: 0px;
}
</style>
